/**
 * Unit 6 (Exolot Husk): requires another friendly unit in front and in flank before deploy.
 * Mirrors orders/complete_special_implementations.js assertExolotHuskDeployAllowed.
 */

export function isExolotHuskOrder(order) {
  return order != null && Number(order.id) === 6;
}

export function isExolotHuskDeployConditionMet(player, excludeInstanceId = null) {
  if (!player?.playedOrders) {
    throw new Error('isExolotHuskDeployConditionMet: player.playedOrders is required');
  }

  const countInZone = (zone) => {
    const row = player.playedOrders[zone];
    if (!Array.isArray(row)) {
      return 0;
    }
    return row.filter(
      (unit) =>
        unit != null
        && (excludeInstanceId == null
          || excludeInstanceId === ''
          || !unit.instanceId
          || unit.instanceId !== excludeInstanceId)
    ).length;
  };

  return countInZone('front') >= 1 && countInZone('flank') >= 1;
}

/**
 * Whether unit 6 should show the affordable/playable hand glow.
 */
export function isExolotHuskHandPlayable(order, player) {
  if (!isExolotHuskOrder(order)) {
    return true;
  }
  const orderType = (order.type && String(order.type).toLowerCase()) || '';
  if (orderType === 'drone' || orderType === 'strategem' || orderType === 'stratagem' || orderType === 'weapon') {
    return true;
  }
  return isExolotHuskDeployConditionMet(player);
}
